module.exports = __webpack_public_path__ + "static/media/green-star.1c6fbaa7.svg";